import { PricingPlan } from './pricingPlans.models'

export function isProPricingPlan(
  plan: Pick<PricingPlan, 'tier' | 'displayName'>,
): boolean {
  return plan.tier === 'PRO' || (plan.tier === undefined && plan.displayName === 'Pro')
}
